/* eslint-disable no-prototype-builtins */
import { Autocomplete } from '../Autocomplete';
import { useField } from 'react-final-form';
import React, { useState } from 'react';
import flatten from 'lodash/flatten';
import isEqual from 'lodash/isEqual';
export function AutocompleteField(props) {
    const { input, meta, not_touched, onChange, ...rest } = props;
    const isInvalid = not_touched ? undefined : meta.invalid;
    const helperText = props.helperText || (isInvalid ? meta.error : '');
    const handleChange = (val) => {
        if (typeof onChange === 'function')
            onChange(val);
        input.onChange(val);
    };
    return (React.createElement(Autocomplete, Object.assign({ helperText: helperText, invalid: isInvalid, value: input.value }, rest, { onChange: handleChange, onBlur: () => input.onBlur(), onFocus: () => input.onFocus() })));
}
export function BasicAutocompleteField({ label, name, options, multiple, validate, onChange, }) {
    const renderProps = useField(name, { validate: validate });
    const [touched, setTouched] = useState(false);
    const onInputChange = (_) => {
        setTouched(true);
    };
    return (React.createElement(AutocompleteField, Object.assign({ options: options, label: label, multiple: multiple, onInputChange: onInputChange, not_touched: !touched, onChange: onChange }, renderProps)));
}
export function ValueAutocompleteField({ label, name, options, multiple, validate, onChange, }) {
    const { input, meta } = useField(name, { validate: validate });
    const [touched, setTouched] = useState(false);
    const onInputChange = (_) => {
        setTouched(true);
    };
    const val = input.value;
    const selectedOption = (Array.isArray(val) && multiple
        ? flatten(val.map(v => options.find(option => isEqual(option.value, v))))
        : options.find(option => isEqual(option.value, val)));
    const handleChange = (val) => {
        if (typeof onChange === 'function')
            onChange(val);
        if (Array.isArray(val) && multiple) {
            input.onChange(val.map(v => v.value));
        }
        else {
            input.onChange(val && val.hasOwnProperty('value') && typeof val !== 'string' && !Array.isArray(val) && val.value);
        }
    };
    const handleBlur = () => {
        input.onBlur();
    };
    const handleFocus = () => {
        input.onFocus();
    };
    return (React.createElement(Autocomplete, { onChange: handleChange, helperText: meta.error, invalid: !touched ? undefined : meta.invalid, value: selectedOption || null, freeSolo: false, label: label, onInputChange: onInputChange, options: options, multiple: multiple, onBlur: handleBlur, onFocus: handleFocus }));
}
//# sourceMappingURL=AutocompleteField.js.map